import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopNavigation from './TopNavigation';
import BottomNavigation from './BottomNavigation';
import ChecklistLogger from './ChecklistLogger';
import { Icon } from './Icon';
import './ChecklistPage.css';

const ChecklistPage = () => {
  const navigate = useNavigate();
  // We need to keep track of log changes even if we don't display the count here directly,
  // as the ChecklistLogger component expects this prop.
  const handleLogChange = () => {
    // Optional: refresh any global state if needed
  };

  return (
    <div className="checklist-page-container">
      <TopNavigation activePage="checklist" />
      
      <main className="checklist-page-main">
        <ChecklistLogger 
          open={true} 
          onClose={() => navigate(-1)} 
          onLogChange={handleLogChange} 
          isPageMode={true}
        />
      </main>

      <BottomNavigation />
    </div>
  );
};

export default ChecklistPage;
